<template>
    <div class="wrapper">
        <div v-if="currentUser">
            <div v-if="roles && roles.length > 0">
                <!-- top navbar-->
                <Header />

                <!-- sidebar-->
                <Sidebar />

                <!-- Main section-->
                <section class="section-container printable">
                    <!-- Page content-->
                    <router-view/>
                </section>

                <!-- Page footer-->
                <Footer />
            </div>
            <div v-else>
                You do not have permission to access this resource.
                <br><br>
                <a href="" @click.prevent="logout" @click.middle.prevent="logout">
                        Log out and return to login page.
                </a>
            </div>
        </div>
        <div v-else>
            Logging you in...
        </div>
    </div>
</template>

<script>
    import Header from './Header'
    import Sidebar from './Sidebar'
    import Footer from './Footer'
    import userManager from '@/services/SecurityService';
    import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
    import { useFeatureFlagsStore } from '@/stores/featureFlags.js';
    import { mapState } from 'pinia';
    import { useCurrentUserStore } from '@/stores/currentUser.js';

    export default {
        name: 'Layout',
        components: {
            Header,
            Sidebar,
            Footer
        },
        computed: {
            ...mapState(useCurrentUserStore, { roles: 'getCurrentUserRoles', currentUser: 'getCurrentUser' })
        },
        methods: {
            logout() {
                userManager.signoutRedirect();
            }
        },
        mounted: async function(){
            selectListOptionsDataContext.getStoreDropdownData('customers');
            selectListOptionsDataContext.getStoreDropdownData('chartOfAccounts');
            selectListOptionsDataContext.getStoreDropdownData('accountTypeEntries');
            selectListOptionsDataContext.getStoreDropdownData('storeTimeZone').then(result => {
                window.timeZone = result;
            });
            await useFeatureFlagsStore().fetchFeatureFlags();
        }
    }
</script>